
























































































































































































































































































































// Vue
import Vue from "vue";
// moment.js
import moment from "moment";
// Services
import JobsService from "../dispatch/jobs/Jobs.service";
// Components
import UpdateJobDialog from "@/views/dispatch/jobs/job-dashboard/_dialogs/UpdateJobDialog.vue";
import ImagesDialog from "@/views/calendar/ImagesDialog.vue";
import ExportJob from "@/core/components/content/ExportJob.vue";
import DaysSelector from "@/core/components/content/DaysSelector.vue";
import { DayOfWeek, allDaysOfWeek, dayOfWeekDisplay } from "@/core/_constants/daysOfWeek.constant";
import { DriverModel } from "@/core/api/apiClient";
import mapQuantityTypeLabel from "@/core/helpers/enum_mappings/QuantityType";
import { Component, Watch } from "vue-property-decorator";

// note:  using class-style components for full typescript support
@Component({
  name: "Calendar",
  components: { UpdateJobDialog, ImagesDialog, ExportJob, DaysSelector }
})
export default class Calendar extends Vue {
  // Data properties
  isLoading = false;
  lastStart: string | Date = "";
  lastEnd: string | Date = "";
  focus = "";
  type: "month" | "week" | "day" = "week";
  typeToLabel = {
    month: "Month",
    week: "Week",
    day: "Day"
  };
  selectedEvent: any = {};
  drivers: DriverModel[] = [];
  selectedElement: HTMLElement | null = null;
  selectedOpen = false;
  events: any[] = [];
  weekdays: DayOfWeek[] = [...allDaysOfWeek];

  // Vuex getters
  get currentUser() {
    return (this as any).$store.getters.currentUser;
  }
  get updateCalendar() {
    return (this as any).$store.getters.updateCalendar;
  }
  get activeJobs() {
    return (this as any).$store.getters.activeJobs;
  }

  // Lifecycle
  async mounted() {
    (this.$refs.calendar as any).checkChange();
    this.drivers = await JobsService.getAllDrivers(this.currentUser.clientId);
    if (this.currentUser.client.workingDays && this.currentUser.client.workingDays.length > 0) {
      this.weekdays = this.currentUser.client.workingDays
        .map((day: string) => {
          // Find the enum key whose display value matches the string
          return Object.entries(dayOfWeekDisplay).find(([key, value]) => value === day)?.[0];
        })
        .map((key) => (key !== undefined ? Number(key) : undefined))
        .filter((v): v is number => typeof v === "number")
        .sort();
    }
  }

  // Methods
  async getCalendarEvents(start: any, end: any) {
    this.isLoading = true;
    this.lastStart = start;
    this.lastEnd = end;

    const data = await JobsService.getJobsDateRange(
      this.currentUser.clientId,
      start,
      end,
      true,
      true,
      true
    );

    console.log("data", data);
    if (!data) {
      this.isLoading = false;
      return;
    }

    const events: any[] = [];
    data.forEach((element: any) => {
      if (!element.deliveryDetails) return;

      let endDate;
      if (element.deliveryDetails.estimateEndDate) {
        endDate = element.deliveryDetails.estimateEndDate;
      } else {
        endDate = moment(element.deliveryDetails.deliveryDate).add(1, "hours").toDate();
      }

      let color = "indigo";
      if (this.isOverdueJob(element.deliveryDetails.deliveryDate)) color = "red";
      if (element.canceled) color = "orange";
      if (element.completed) color = "green";

      let event = {
        job: element,
        name: element.customer?.name ?? "",
        start: element.deliveryDetails?.deliveryDate ?? null,
        end: endDate,
        color: color,
        timed: true
      };

      if (new Date(event.end) < new Date(event.start)) {
        const startDate = new Date(event.start);
        const endTime = new Date(event.end);
        event.end = new Date(
          startDate.getFullYear(),
          startDate.getMonth(),
          startDate.getDate(),
          endTime.getHours(),
          endTime.getMinutes(),
          endTime.getSeconds()
        );
      }
      events.push(event);
    });

    this.events = events;
    this.isLoading = false;
  }

  refreshMonth() {
    if (this.type === "month") {
      this.type = "day";
      setTimeout(() => {
        this.type = "month";
      }, 500);
    }
  }

  handleWeekdaysInput() {
    if (this.weekdays.length === 0) {
      this.weekdays = [...allDaysOfWeek];
    }
    this.weekdays.sort();
  }

  viewDay({ date }: { date: string }) {
    this.focus = date;
    this.type = "day";
  }

  getEventColor(event: any) {
    return event.color;
  }

  setToday() {
    this.focus = "";
  }

  prev() {
    (this.$refs.calendar as any).prev?.();
  }

  next() {
    (this.$refs.calendar as any).next?.();
  }

  showEvent({ nativeEvent, event }: { nativeEvent: any; event: any }) {
    const open = () => {
      this.selectedEvent = event;
      this.selectedElement = nativeEvent.target;
      requestAnimationFrame(() => requestAnimationFrame(() => (this.selectedOpen = true)));
    };

    if (this.selectedOpen) {
      this.selectedOpen = false;
      requestAnimationFrame(() => requestAnimationFrame(() => open()));
    } else {
      open();
    }

    nativeEvent.stopPropagation();
  }

  updateRange({ start, end }: { start: any; end: any }) {
    let startDate = start;
    let endDate = end;

    if (start.date) startDate = new Date(start.year, start.month - 1, start.day - 1, 0, 0);
    if (end.date) endDate = new Date(end.year, end.month - 1, end.day, 23, 59);

    this.getCalendarEvents(startDate, endDate);
  }

  isOverdueJob(date: any) {
    const testDate = moment(date);
    const currentDate = moment(new Date());
    return testDate < currentDate;
  }

  // Computed
  get isTodayInContext() {
    if (this.focus === "") return true;
    const dateScheduler = moment(this.focus);
    return dateScheduler.isSame(moment.now(), this.type);
  }

  // Watchers
  @Watch("updateCalendar")
  onUpdateCalendar() {
    if (this.updateCalendar) {
      this.getCalendarEvents(this.lastStart, this.lastEnd);
      this.$store.dispatch("SET_UPDATE_CALENDAR", false);
      this.refreshMonth();
    }
  }

  @Watch("activeJobs")
  onActiveJobs() {
    this.getCalendarEvents(this.lastStart, this.lastEnd);
  }

  // Filters (use as methods or computed in class-style)
  moment(date: any) {
    return moment(date).format("MMMM Do YYYY, h:mm A");
  }

  mapQuantityType(quantityType: any) {
    return quantityType ? mapQuantityTypeLabel(quantityType) : "";
  }

  materialName(job: any) {
    if (!job.material) return "";
    return job.material.customName || (job.material.material && job.material.material.name) || "";
  }

  quantityName(job: any) {
    if (!job.quantity) return "";
    return job.quantity.customName || (job.quantity.quantity && job.quantity.quantity.name) || "";
  }

  applicationName(application: any) {
    return application.customName || (application.application && application.application.name) || "";
  }
}
